import gql from 'graphql-tag';

export const GET_EMBEDDED_ANALYSIS_INPUT_DATASETS_QUERY = gql`
  query GetEmbeddedAnalysisInputDatasets($dataFrameIds: [StrictString]!)
  @skipAudit
  @engComponent(name: ANALYSIS_TOOL) {
    dataFrames(ids: $dataFrameIds) {
      ... on DataFrameNode {
        id
        dataset {
          id
        }
      }
    }
  }
`;
